<template>
  <div class="test-outbound-gateway-wrapper">
    <template v-if="step === 0">
      <div class="d-flex justify-center mt-12 mb-6">
        <v-icon class="email-icon" size="80" icon="$emailNoHex" />
      </div>
      <div>{{ $t("modals.testOutboundGateway.description1") }}</div>
      <a class="mt-2 font-weight-bold coro-link" :href="mailClientRedirectUrl" target="_blank">
        {{ $t("modals.testOutboundGateway.redirectToEmailProviderLink") }}
      </a>
      <div class="mt-2 font-weight-bold">{{ $t("modals.testOutboundGateway.description2") }}</div>

      <v-btn class="mt-4" color="primary" rounded @click="step++">
        {{ $t("general.confirm") }}
      </v-btn>
    </template>
    <template v-if="step === 1">
      <div class="d-flex justify-center mt-12 mb-6">
        <v-icon class="email-icon" size="80" icon="$proxySettings" />
      </div>
      <div class="font-weight-bold">{{ $t("modals.testOutboundGateway.step2Description1") }}</div>
      <div class="text-center">{{ $t("modals.testOutboundGateway.step2Description2") }}</div>

      <v-btn class="mt-4" color="primary" rounded @click="close()">
        {{ $t("general.done") }}
      </v-btn>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { RouteName } from "@/constants/routes.ts";
import { useGatewaySettingsStore } from "@/_store/gateway-settings.module.ts";
import { useI18n } from "vue-i18n";

export default defineComponent({
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const gatewaySettingsStore = useGatewaySettingsStore();
    const step = ref(0);
    const i18n = useI18n();
    const mailClientRedirectUrl = ref("");

    onMounted(async () => {
      const domainVerificationEmail = await gatewaySettingsStore.testDomain(props.config.item);

      mailClientRedirectUrl.value = `mailto:${domainVerificationEmail}?subject=${i18n.t("modals.testOutboundGateway.testEmailSubject")}&body=${i18n.t("modals.testOutboundGateway.testEmailBody")}`;
    });

    const close = () => {
      emit("dismissed");
    };

    return {
      close,
      step,
      RouteName,
      mailClientRedirectUrl,
    };
  },
});
</script>
<style lang="scss" scoped>
.email-icon:before {
  color: rgb(var(--v-theme-indigo-light)) !important;
}

.test-outbound-gateway-wrapper {
  height: 450px !important;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
